import { useState } from "react";
import { faqs } from "../../../mocks/Cleario";
import WaveDivider from "./WaveDivider";

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const leftFaqs = faqs.filter((_, i) => i % 2 === 0);
  const rightFaqs = faqs.filter((_, i) => i % 2 !== 0);

  const AccordionItem = ({
    faq,
    idx,
  }: {
    faq: { question: string; answer: string };
    idx: number;
  }) => {
    const isOpen = openIdx === idx;
    return (
      <div
        className={`rounded-2xl mb-3 cursor-pointer overflow-hidden transition-all thick-border ${isOpen ? "cartoon-shadow-green" : "cartoon-shadow-sm"}`}
        style={{ background: "#ffffff" }}
        onClick={() => setOpenIdx(isOpen ? null : idx)}
      >
        <div className="flex items-start justify-between gap-4 px-5 py-4">
          <p className={`font-black text-sm leading-snug transition-colors ${isOpen ? "text-cl-green" : "text-cl-dark"}`}>
            {faq.question}
          </p>
          <span
            className={`w-8 h-8 flex items-center justify-center rounded-xl flex-shrink-0 border-2 transition-all ${
              isOpen ? "bg-cl-green text-white border-[#4a8c0a]" : "bg-gray-100 text-cl-dark border-gray-300"
            }`}
          >
            <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-sm font-black`}></i>
          </span>
        </div>
        {isOpen && (
          <div className="px-5 pb-5">
            <p className="text-cl-dark/70 text-sm leading-relaxed font-semibold">{faq.answer}</p>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <section id="faq" className="py-20 bg-cl-tint">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          {/* Header */}
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
            <div>
              <div className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
                <span className="text-cl-dark text-xs font-black uppercase tracking-widest">Got Questions?</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-black text-cl-dark leading-tight">
                The stuff everyone<br />wants to know.
              </h2>
            </div>
            <a
              href="#"
              className="inline-flex items-center gap-2 bg-white text-cl-dark font-black px-7 py-3.5 rounded-2xl text-sm cartoon-btn cursor-pointer whitespace-nowrap"
            >
              View all FAQs
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* 2-col accordion */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 mb-12">
            <div>
              {leftFaqs.map((faq, i) => (
                <AccordionItem key={i} faq={faq} idx={i * 2} />
              ))}
            </div>
            <div>
              {rightFaqs.map((faq, i) => (
                <AccordionItem key={i} faq={faq} idx={i * 2 + 1} />
              ))}
            </div>
          </div>

          {/* Help CTA */}
          <div className="bg-cl-dark rounded-3xl px-8 py-8 flex flex-col lg:flex-row items-center gap-8 thick-border cartoon-shadow">
            <span className="w-16 h-16 flex items-center justify-center rounded-2xl bg-cl-lime border-2 border-white/20 flex-shrink-0 cartoon-shadow-sm">
              <i className="ri-customer-service-2-line text-cl-green text-3xl"></i>
            </span>
            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-white font-black text-2xl mb-1">Still need a hand?</h3>
              <p className="text-white/60 text-sm font-semibold">Our friendly team is available 7 days a week — give us a ring or get a quote online.</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="tel:03335775445"
                className="inline-flex items-center justify-center gap-2 bg-white/10 border-2 border-white/20 text-white font-black px-7 py-3.5 rounded-2xl text-sm cartoon-btn whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill"></i>
                03335 775445
              </a>
              <a
                href="#"
                className="inline-flex items-center justify-center gap-2 bg-cl-green text-white font-black px-7 py-3.5 rounded-2xl text-sm cartoon-btn-green whitespace-nowrap cursor-pointer"
              >
                <i className="ri-price-tag-3-line"></i>
                Get a Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Wave into Footer (dark) */}
      <WaveDivider fromColor="#e8f0fc" toColor="#09245b" />
    </div>
  );
}
